<template>
    <TableFilter :filter-refs="$refs"
                 @apply-filter="applyFilter"
    >
        <div class="filter_item filter_item_xl">
            <TextFilter :label-text="this.$t('common.name')"
                         columnName="tag"
                         ref="filter_tag"
            ></TextFilter>
            <TextFilter :label-text="this.$t('common.iban')"
                         columnName="iban"
                         ref="filter_iban"
            ></TextFilter>
            <TextFilter :label-text="this.$t('common.bic')"
                         columnName="bic"
                         ref="filter_bic"
            ></TextFilter>
            <CurrencyFilter columnName="currency"
                            ref="filter_currency"
            ></CurrencyFilter>
            <EnumFilter :label-text="this.$t('common.status')"
                         columnName="status"
                         :enumDef="enumDef.accountStatus"
                         ref="filter_status"
            ></EnumFilter>
        </div>
    </TableFilter>
</template>

<script>
import TableFilter from "@/components/newFilter/TableFilter";
import TextFilter from "@/components/newFilter/TextFilter";
import FromToFilter from "@/components/newFilter/FromToFilter";
import CurrencyFilter from "@/components/newFilter/CurrencyFilter";
import EnumFilter from "@/components/newFilter/EnumFilter";
import {enumDef} from "@/common/enumDefs";

export default {
    components: {
        EnumFilter,
        CurrencyFilter,
        FromToFilter,
        TextFilter,
        TableFilter
    },
    data() {
        return {
            enumDef: enumDef
        };
    },
    methods: {
        applyFilter(filters) {
            this.$emit("apply-filter", filters);
        },
    }
};
</script>
